import React, { useState } from 'react';
import PaymentRow from './PaymentRow';
import styles from './PaymentsList.module.css';

const FILTERS = [
  { key: 'open', label: 'Em aberto', empty: 'Nenhum atendimento em aberto.' },
  { key: 'paid', label: 'Pagos', empty: 'Nenhum pagamento registrado.' },
];

/** Filtro "Em aberto | Pagos" em pílulas, com a contagem de cada um. */
export function PaymentsFilter({ value, onChange, counts }) {
  return (
    <div className={styles.filter} role="tablist" aria-label="Filtrar atendimentos">
      {FILTERS.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          role="tab"
          aria-selected={value === key}
          className={`${styles.pill} ${value === key ? styles.pillActive : ''}`}
          onClick={() => onChange(key)}
        >
          {label}
          <span className={styles.count}>{counts[key]}</span>
        </button>
      ))}
    </div>
  );
}

/** Lista dos atendimentos do filtro escolhido; vazia, uma linha só. */
export function PaymentsList({ filter, items }) {
  const definition = FILTERS.find((f) => f.key === filter) || FILTERS[0];

  return (
    <div className={styles.card}>
      {items.length === 0
        ? <p className={styles.empty}>{definition.empty}</p>
        : (
          <ul className={styles.list}>
            {items.map((item) => <PaymentRow key={item.id} item={item} />)}
          </ul>
        )}
    </div>
  );
}

/** Estado do filtro: começa em "Em aberto" quando há algo lá, senão em "Pagos". */
export function usePaymentsFilter(open, paid) {
  const [filter, setFilter] = useState(open.length > 0 || paid.length === 0 ? 'open' : 'paid');
  const items = filter === 'open' ? open : paid;
  const counts = { open: open.length, paid: paid.length };
  return { filter, setFilter, items, counts };
}
